<div (mousedown)="preventDrag($event)" (click)="shadeClicked()" class="modal-full-shade" [class.transparent]="!shade"></div>
  <div
    (mousedown)="preventDrag($event)"
    class="modal-box"
    [style.width.px]="width"
    [ngClass]="www ? 'position-in-iframe' : 'position-in-app'">
    <button *ngIf="removeVisible" class="btn btn-xs btn-link" (click)="shadeClicked()">
      <i class="fas fa-times text-red"></i>
    </button>
    <div class="modal-stuff" (click)="shadeClickedIf($event)">
      <div id="brand-modal" class="modal-background" [class.modal-border]="!shade">
        <ng-content></ng-content>
      </div>
    </div>
  </div>